import { render, staticRenderFns } from "./StepLivestock.vue?vue&type=template&id=5f574310&lang=html&"
import script from "./StepLivestock.vue?vue&type=script&lang=js&"
export * from "./StepLivestock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports